<template>
  <div class="bg-white rounded">
    <div>
      <section-title container-class=" mt-2 mb-2 " :content="titleName" />
      <custom-callout class="mb-3 custom-callout" :has-toggle="false">
        <div class="row py-3 m-0">
          <div class="col-md-3 col-12 col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal mr-2">
              Tipo de Documento:
            </div>
            <div class="color-black font-16 font-weight-normal">
              Guía de Referido para Servicios de Asistencia Tecnológica
            </div>
          </div>
          <div class="col-md-3 col-12 col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal mr-2">
              Archivo:
            </div>
            <div class="color-black font-16 font-weight-normal">
              Documento.pdf
            </div>
          </div>
          <div
            class="col-md-6 col-12 col-spacing student-spacing justify-content-end d-flex"
          >
            <action-button
              class="btn-action-size ml-2 mt-3"
              i="fas fa-file-download"
              variant="success"
              @click="handlerDownloadGuia"
            />
          </div>
        </div>
      </custom-callout>
    </div>
    <div>
      <section-title
        container-class=" mt-2 mb-2 "
        content="Documentos de Evaluaciones Incluidas en la Guía"
      />
      <div v-for="(item, index) in evaluations" :key="index">
        <div v-for="doc in item.document || []" :key="doc.id">
          <custom-callout class="mb-3 custom-callout" :has-toggle="false">
            <div class="row py-3 m-0">
              <div class="col-md-3 col-12 col-spacing student-spacing">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Tipo de Documento:
                </div>
                <div class="color-black font-16 font-weight-normal">
                  {{ item.documentAttachmentTypes }}
                </div>
              </div>
              <div class="col-md-3 col-12 col-spacing student-spacing">
                <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                  Archivo:
                </div>
                <div class="color-black font-16 font-weight-normal">
                  {{ item.fullName }}.pdf
                </div>
              </div>
              <div
                class="col-md-6 col-12 col-spacing student-spacing justify-content-end d-flex"
              >
                <action-button
                  class="btn-action-size ml-2 mt-3"
                  i="fas fa-file-download"
                  variant="success"
                  @click="() => handlerDownloadDocument(doc)"
                />
              </div>
            </div>
          </custom-callout>
        </div>
      </div>
    </div>
    <div>
      <section-title
        container-class=" mt-2 mb-2 "
        content="Documentos Adicionales"
      />
      <div v-for="item in additionalDocuments" :key="item.id">
        <custom-callout
          class="mb-3 custom-callout"
          :has-toggle="false"
          v-if="item"
        >
          <div class="row py-3 m-0">
            <div class="col-md-3 col-12 col-spacing student-spacing">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Tipo de Documento:
              </div>
              <div class="color-black font-16 font-weight-normal">
                {{ item.type }}
              </div>
            </div>

            <div class="col-md-3 col-12 col-spacing student-spacing">
              <div class="color-secondary-6 font-14 font-weight-normal mr-2">
                Archivo:
              </div>
              <div class="color-black font-16 font-weight-normal">
                {{ item.name }}.pdf
              </div>
            </div>

            <div
              class="col-md-6 col-12 col-spacing student-spacing justify-content-end d-flex align-items-center"
            >
              <template v-if="replacingDocumentId !== item.id">
                <action-button
                  class="btn-action-size ml-2 mt-3"
                  i="fas fa-file-download"
                  variant="success"
                  @click="() => handlerDownloadDocument(item)"
                />
                <action-button
                  v-if="canReplace"
                  class="btn-action-size ml-2 mt-3"
                  i="fas fa-times"
                  variant="danger"
                  @click="() => (replacingDocumentId = item.id)"
                />
              </template>

              <template v-else>
                <custom-file-input
                  :key="`fileReplace-${item.id}`"
                  :id="`fileReplace-${item.id}`"
                  accept=".pdf"
                  class="file-input__extended mt-3"
                  custom-error-msg="El archivo es requerido."
                  display-style="normal"
                  :name="item.name"
                  :on-download="() => handlerDownloadDocument(item)"
                  @input="(file) => onReplaceDocumentHandler(file, item)"
                />
                <action-button
                  class="btn-action-size ml-2 mt-3"
                  i="fas fa-times"
                  variant="danger"
                  @click="replacingDocumentId = null"
                />
              </template>
            </div>
          </div>
        </custom-callout>
      </div>
      <custom-callout
        class="mb-3 custom-callout"
        :has-toggle="false"
        v-if="peiId"
      >
        <div class="row py-3 m-0">
          <div class="col-md-3 col-12 col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal mr-2">
              Tipo de Documento:
            </div>
            <div class="color-black font-16 font-weight-normal">
              PEI Electrónico - {{ peiId }}
            </div>
          </div>
          <div class="col-md-3 col-12 col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal mr-2">
              Archivo:
            </div>
            <div class="color-black font-16 font-weight-normal">
              PEI Electrónico - {{ peiId }}.pdf
            </div>
          </div>
          <div
            class="col-md-6 col-12 col-spacing student-spacing justify-content-end d-flex"
          >
            <action-button
              class="btn-action-size ml-2 mt-3"
              i="fas fa-file-download"
              variant="success"
              @click="() => handlerDownloadPeiReport()"
            />
          </div>
        </div>
      </custom-callout>
    </div>
  </div>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomCallout from 'custom-callout';
import CustomFileInput from 'CustomFileInput';
import ActionButton from 'ActionButton';
import peiAtReferralType from '@/utils/constants/peiAtReferralType';
import documentsService from '@/services/api/document.api';
import reportService from '@/services/api/report.api.js';
import referralAndEquipmentsservice from '@/services/api/referralsandequipments.api';
import documentTypes from '@/utils/constants/documentTypes';
import mixAlert from '@/mixins/alert.mixin';

export default {
  name: 'Documents',
  components: {
    SectionTitle,
    CustomCallout,
    ActionButton,
    CustomFileInput,
  },
  mixins: [mixAlert],
  props: {
    referral: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      documents: {},
      replacingDocumentId: null,
    };
  },
  computed: {
    evaluations() {
      return this.documents?.evaluations || [];
    },
    additionalDocuments() {
      return this.documents?.additionalDocuments || [];
    },
    validType() {
      return [
        peiAtReferralType.EquipmentRelatedServiceRequest,
        peiAtReferralType.TechnicalAssistanceServiceRequest,
      ].includes(this.referral.referralTypeId);
    },
    titleName() {
      return this.validType
        ? 'Referido Solicitud de Servicios de Asistencia Tecnológica'
        : 'Guía de Referido Para Servicios de Asistencia Tecnología';
    },
    peiId() {
      return this.referral.peiId;
    },
    canReplace() {
      return this.userHasPermissions(
        'technologyassistance.referralmanagment.replacement.signedtechnologicalassistanceevaluationdocument'
      );
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const { data } = await referralAndEquipmentsservice.getDocuments(
        this.referral.id
      );
      console.log('documents:', data);
      this.documents = data;
    },
    async handlerDownloadDocument(document) {
      await documentsService.downloadatdocument(
        document.id,
        this.referral.id,
        document.documentTypeId
      );
    },
    async handlerDownloadGuia() {
      if (this.validType) {
        await documentsService.downloadatdocument(
          '',
          this.referral.id,
          documentTypes.ReferralServiceAT
        );
      } else {
        reportService.downloadAtReport(this.referral.peiId);
      }
    },

    async handlerDownloadPeiReport() {
      reportService.downloadPEIReport(this.referral.peiId);
    },
    async handlerDownloadATEvaluatedReportSigned() {
      const { data } = await referralAndEquipmentsservice.getFileEvaluationInfo(
        this.referral.id
      );
      await documentsService.downloadFile(data);
    },
    async onReplaceDocumentHandler(file, item) {
      if (!file) return;

      const result = await this.submitReplaceDocument(file, item.id);

      if (result) {
        this.ShowToast(
          'Éxito',
          'Se ha reemplazado el documento correctamente',
          'success'
        );

        this.replacingDocumentId = null;
        console.log(
          'replacingDocumentId after reset:',
          this.replacingDocumentId
        );

        await this.$nextTick();
        await this.init();

        console.log(
          'additionalDocuments after init:',
          this.additionalDocuments
        );
        console.log(
          'ids after init:',
          this.additionalDocuments.map((x) => x.id)
        );
      }
    },

    async submitReplaceDocument(file, documentId) {
      try {
        const formData = new FormData();
        formData.append('document', file);

        const { data } = await referralAndEquipmentsservice.replaceDocument(
          documentId,
          formData
        );
        return data;
      } catch {
        return false;
      }
    },
  },
};
</script>
<style lang="scss"></style>
